import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'tenant-print-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  template: `<div class="w-screen min-h-screen bg-white">
    <router-outlet></router-outlet>
  </div>`,
  styles: `
    
  `,
})
export class PrintLayoutComponent {}
